export class User {
    public name: string;
    public email: string;
    public avatarUrl: string;
    public creationDate: string;
    public preferredLang: string;
    public connected: boolean = false;
    public adminId: number;
    public adminName: string;
    public username: string;
    public role: string;
    public clientId: number;
    public company: string;
    public centralAdmin: string;
    public userGroupId; number;

    public constructor(data: any = {}) {
        this.name = data.name || '';
        this.email = data.email || '';
        this.avatarUrl = data.avatarUrl || '';
        this.creationDate = data.creation_date || Date.now();
        this.preferredLang = data.preferredLang || null;
        this.connected = data.connected || false;
        this.role = data.role || '';
        this.username = data.username || '';
        this.adminId = data.adminId || null;
        this.clientId = data.clientId || null;
        this.company = data.company || '';
        this.centralAdmin = data.centralAdmin || '';
    }

    public getName() {
        return this.name;
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/models/user.ts